import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import Layout from "./components/Layout";
import LoadingSpinner from "./components/LoadingSpinner";

const HomePage = lazy(() => import("./pages/HomePage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const PricingPage = lazy(() => import("./pages/PricingPage"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const SupportCenter = lazy(() => import("./pages/SupportCenter"));
const ComingSoon = lazy(() => import("./pages/ComingSoon"));

// Product pages - individual lazy imports (no top-level await)
const SmsPage = lazy(() => import("./pages/ProductPages").then((m) => ({ default: m.SmsPage })));
const EmailPage = lazy(() => import("./pages/ProductPages").then((m) => ({ default: m.EmailPage })));
const VoicePage = lazy(() => import("./pages/ProductPages").then((m) => ({ default: m.VoicePage })));
const WhatsappPage = lazy(() => import("./pages/ProductPages").then((m) => ({ default: m.WhatsappPage })));
const USSDPage = lazy(() => import("./pages/ProductPages").then((m) => ({ default: m.USSDPage })));
const WhatsappOtp = lazy(() => import("./pages/ProductPages").then((m) => ({ default: m.WhatsappOtp })));

const ApiDocsPage = lazy(() => import("./pages/ApiDocsPage"));

function App() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<SupportCenter />} />
          <Route path="/products/sms" element={<SmsPage />} />
          <Route path="/products/email" element={<EmailPage />} />
          <Route path="/products/voice-messaging" element={<VoicePage />} />
          <Route path="/products/whatsapp-messaging" element={<WhatsappPage />} />
          <Route path="/products/ussd" element={<USSDPage />} />
          <Route path="/products/whatsapp-otp" element={<WhatsappOtp />} />
          <Route path="/api-docs" element={<ApiDocsPage />} />
          <Route path="/api-doc" element={<ApiDocsPage />} />
          <Route path="/blog" element={<ComingSoon />} />
          <Route path="/report-and-tools" element={<ComingSoon />} />
          <Route path="/events" element={<ComingSoon />} />
          <Route path="*" element={<ComingSoon />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;